<template>
<div class="chapter">
<div class="inner_page">
<div id="maps">
<h1 style="margin-top:3em;font-size:1.5em;font-weight:normal;">LIST OF MAPS</h1>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/14_chapter_4#map1" title="Link target outside of Sample">NORTH SEA, NORWAY AND MURMANSK</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/16_chapter_6#map2" title="Link target outside of Sample">MEDITERRANEAN</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/24_chapter_13#map3" title="Link target outside of Sample">INDIAN OCEAN, CEYLON TO MALACCA STRAITS</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/25_chapter_14#map4" title="Link target outside of Sample">MALACCA STRAITS, IN THE NARROWS</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/27_chapter_16#map5" title="Link target outside of Sample">ANDAMAN ISLANDS, PORT BLAIR</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/28_chapter_17#map6" title="Link target outside of Sample">PULO WEH AND SABANG</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/30_chapter_19#map7" title="Link target outside of Sample">MERGUI ARCHIPELAGO, NORTHERN HALF</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/32_chapter_21#map8" title="Link target outside of Sample">LOMBOK STRAIT</span></p>
<p class="paranoindent1" style="font-size:.9em;"><span href="#/text/32_chapter_21#map8" title="Link target outside of Sample">WESTERN AUSTRALIA AND DUTCH EAST INDIES (<em>inset</em>)</span></p>
<p class="paracenter" style="font-size:1.1em;">(<em>The maps were prepared by K. C. Jordan</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08b_maps.vue?2027cdac